module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAAAXNSR0IArs4c6QAAANpJREFUOBFjZMABvnt4NDAyMtZjk/7//38j544dDdjkmLAJUiI2aiAloQfROxqGgzAMWX65uhowsrDwo7vt3///8v/RBaF8YEzK//b0tEeX/v/nz0dGkIH/mJkPMDAyYhiKrgEv////j0x//zowghRRbCjUMLbduy+ADaTIUCTDQObAEzbIdGCYFYAESQEgPSC9MD1wF8IEgOVgArAcnA/j46OB5WIisFxcgKwGw0CQJDGGYjMMpBergYQMxWUYXgNxGYrPMIIGohtKyDCQeqLAD0/PAlC4EqMYAHOuZeplrfl6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/fileLoader/images/error_icon.png
// module id = 407
// module chunks = 0